import { DatePicker } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";
import type { TimeRangePickerProps } from "antd";

const { RangePicker } = DatePicker;
type TimeRangeInputProps = {
    onChange?: (value: [dayjs.Dayjs, dayjs.Dayjs]) => void;
    value?: [dayjs.Dayjs, dayjs.Dayjs];
};
export const TimeRangeInput: React.FC<TimeRangeInputProps> = ({ onChange, value }) => {
    const disabledDate: RangePickerProps["disabledDate"] = (current, { from }) => {
        const today = dayjs();
        const yesterday = today.subtract(1, "day");
        const twoYearsAgo = today.subtract(2, "year");

        if (!current) return true;

        if (current.isAfter(yesterday.toDate()) || current.isBefore(twoYearsAgo.toDate())) {
            return true;
        }

        if (from) {
            return Math.abs(current.diff(from, "days")) >= 90;
        }

        return false;
    };
    const RangePresetsDefault: TimeRangePickerProps["presets"] = [
        { label: "Last 7 Days", value: [dayjs().add(-8, "d"), dayjs().add(-1, "d")] as any },
        { label: "Last 14 Days", value: [dayjs().add(-15, "d"), dayjs().add(-1, "d")] as any },
        { label: "Last 30 Days", value: [dayjs().add(-31, "d"), dayjs().add(-1, "d")] as any },
        { label: "Last 90 Days", value: [dayjs().add(-90, "d"), dayjs().add(-1, "d")] as any },
    ];
    return (
        <RangePicker
            disabledDate={disabledDate}
            presets={RangePresetsDefault}
            style={{
                width: 400,
                backgroundColor: "white",
            }}
            onChange={(dates) => {
                onChange?.(dates as [dayjs.Dayjs, dayjs.Dayjs]);
            }}
        />
    );
};
